"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  if (typeof twttr !== "undefined" && twttr.widgets && typeof twttr.widgets.load === "function") {
    twttr.widgets.load();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-twitter/gatsby-browser.js
// module id = 386
// module chunks = 231608221292675